import { useFile, useFileVersionFromFileId } from '@witmetrics/data-store';
import { useLoadedFiles } from '@/providers/LoadedFilesProvider';
import { showErrorToaster } from '@/utils/toasters';
import { openFileDownloadLink } from '@/utils/files';
import Button from '@/components/Button';
import LoadedFileViewer from '@/components/viewers/LoadedFileViewer';
import { DownloadIcon } from '@/icons';
import { classes } from './utils';

export type ViewerContentProps = {
  isLoading: boolean;
  fileId: number;
};

export default function ViewerContent({
  isLoading,
  fileId,
}: ViewerContentProps) {
  const file = useFile(fileId);
  const fileVersion = useFileVersionFromFileId(fileId);
  const { loadedFiles } = useLoadedFiles();

  const handleDownloadFile = () => {
    if (!fileVersion) return showErrorToaster('Error downloading file');
    return openFileDownloadLink(fileVersion.id, fileVersion.name);
  };

  return (
    <LoadedFileViewer
      isLoading={isLoading}
      floatingHeader
      file={file}
      loadedFile={loadedFiles[fileId]}
      unsupportedFallback={
        <Button className={classes.downloadButton} onClick={handleDownloadFile}>
          <DownloadIcon />
          Download file
        </Button>
      }
    />
  );
}
